import {
  Component, Input, OnChanges, OnDestroy,
  OnInit, SimpleChanges, ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import FileSaver from 'file-saver';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActionState } from 'src/app/enums/action-state.enum';
import { AlarmsColumns } from 'src/app/enums/alarms/alarms-columns';
import { TableAlarmListMapper } from 'src/app/mapper/table/table-alarm-list.mapper';
import { DisplayText } from 'src/app/models/events/displayText';
import { EventsActionFilters } from 'src/app/models/events/eventsActionFilters';
import { EventColumn } from 'src/app/models/events/eventsColumn';
import { AlarmRepo } from 'src/app/repositories/alarm-repo';
import { AlertService } from 'src/app/services';
import { RightService } from 'src/app/services/right.service';
import {
  AlertAction,
  AlertParameters,
  AlertType
} from 'src/app/shared/models/models-index';
import { EventEmitterFilters } from 'src/app/shared/models/table/event-emitter-filters';
import FiltersConfig from 'src/app/shared/models/table/filters-config';
import { IconType } from 'src/app/tinea-components/icon/enum/icon-type';
import { LinkClickSateType } from 'src/app/tinea-components/paging/enum/link-click-state-type';
import { PagingModel } from 'src/app/tinea-components/paging/models/input/paging-model';
import { TableModel } from 'src/app/tinea-components/table/models/input/table-model';
import { UiIcon } from 'src/app/tinea-components/table/models/input/ui-icon';
import { TableOutputEvent } from 'src/app/tinea-components/table/models/table-output-event';
import { TableOutputRowEvent } from 'src/app/tinea-components/table/models/table-output-row-event';
import { coreEnvironment } from 'src/environments/core/core.environment';
import {
  AlarmRealTime,
  AlarmRealTimePaginatedList, AlarmSearchBodyV2, AlarmSearchFilterParams, AlarmSortFieldName,
  AlarmState,
  ApplicationFeature, MatchingType, TicketSearchFilter
} from 'src/swagger-gen/web-secured/models';


@Component({
    selector: 'app-alarms-list',
    templateUrl: './alarms-list.component.html',
    styleUrls: ['./alarms-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlarmsListComponent implements OnInit, OnDestroy, OnChanges {
  @Input() eUid?: string;
  @Input() allowGlobalActions: boolean;
  @Input() filters: ParamMap;

  FEATURE = ApplicationFeature;

  table: TableModel;
  paging: PagingModel;

  actionOnAlarms: boolean = coreEnvironment.actionOnAlarms;

  alarms: AlarmRealTimePaginatedList;
  filtersConfig: FiltersConfig;
  fullColumnList: Array<EventColumn>;

  matchingType = MatchingType.EXACT_MATCH_IGNORE_CASE;
  newItemFilter: EventsActionFilters = new EventsActionFilters();
  dataForChildComponent: any = {};

  loadingState = new BehaviorSubject(ActionState.LOADING);
  actionState = ActionState;

  private subscriptions: Subscription[] = [];
  errorMessage: string;
  acknowledgingAll = false;

  offsetEvent = 0;
  limitEvent = 25;

  isoldTableView: boolean;

  constructor(
      private logger: NGXLogger,
      private alarmsService: AlarmRepo,
      private router: Router,
      private rightService: RightService,
      private tableAlarmListMapper: TableAlarmListMapper,
      private translate: TranslateService,
      private alertService: AlertService
  ) {
    this.dataForChildComponent.body = {
      filters: [],
    };
  }

  ngOnInit() {
    this.fullColumnList = [
      // new EventColumn(
      //   true,
      //   new DisplayText(
      //     AlarmsColumns.TICKET_ID,
      //     this.translate.instant('tickets.id_ticket')
      //   )
      // ),
      new EventColumn(
        true,
        new DisplayText(
          AlarmsColumns.DATE_STATE,
          this.translate.instant('alarms.date')
        )
      ),
      new EventColumn(
        true,
        new DisplayText(
          AlarmsColumns.TAG,
          this.translate.instant('alarms.alias')
        )
      ),
      new EventColumn(
        true,
        new DisplayText(
          AlarmsColumns.MESSAGE,
          this.translate.instant('alarms.detail')
        )
      ),
      new EventColumn(
        true,
        new DisplayText(
          AlarmsColumns.ACTION,
          this.translate.instant('alarms.action')
        )
      ),
      new EventColumn(
        true,
        new DisplayText(
          AlarmsColumns.STATE,
          this.translate.instant('alarms.state')
        )
      ),
    ];
    if (!this.eUid) {
      this.fullColumnList.push(
        new EventColumn(
          true,
          new DisplayText(
            AlarmsColumns.STATION_NAME,
            this.translate.instant('alarms.station')
          )
        )
      );
    }
    this.filtersConfig = {
      date: true,
      column: {
        fullColumnList: this.fullColumnList,
      },
      export: {
        show: true,
        isLoading: false,
      },
      sort: {
        paramsToInclude: Object.values(AlarmSortFieldName),
        defaultSort: AlarmSortFieldName.DATE_STATE,
      },
      search: {
        paramsToInclude: [
          'STATION_NAME',
          'MESSAGE',
        ],
      },
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.filters && changes.filters.currentValue) {
       // this.getAlarms();
    }
    // dès le click search-alarme-list va changer les valeurs du boutons
  }

  /**
   * Making a table filters list from parameters in url.
   * @param params params from url
   * @param type caller page type used for translations
   * @returns a list of filters, for now, only AlarmSearchFilterParams, but you can add any other
   */
  getFiltersFromParams(params: ParamMap): AlarmSearchFilterParams[] {
    const keys: string[] = params.keys;
    // this.loggerService.trace('keys', keys);
    const filters: AlarmSearchFilterParams[] = [];
    keys.forEach((key) => {
      if (key === 'states') {
        const states: string[] = params.get(key).split(',');
        // this.loggerService.trace('keys', states);
        states.forEach((state) => {
          // this.loggerService.trace('state', state);
          const filter: any = {
            value: state,
            field: TicketSearchFilter.STATE,
            matchingType: MatchingType.EXACT_MATCH_IGNORE_CASE,
          };

          // this.loggerService.trace('state filter', filter);
          filters.push(filter);
        });
      }
    });

    return filters;
  }

  /***************************************  APPEL API  **********************************/
  getAlarms() {
      const params = this.dataForChildComponent.params || [];
      const filterBody = this.getBody();
      const body: AlarmSearchBodyV2 = {};

      const searchFilter = filterBody.filters.find(f => f.field === 'ALL')?.value;
      const searchParam = params.find(p => p.key === 'search');
      if (searchParam) {
        searchParam.value = searchFilter ?? '';
      } else {
        params.push({key: 'search', value: searchFilter ?? ''});
      }

      const stationNameFilter = filterBody.filters.find(f => f.field === 'STATION_NAME')?.value;
      if (stationNameFilter) {
        body.stationName = stationNameFilter;
      }

      const messageFilter = filterBody.filters.find(f => f.field === 'MESSAGE')?.value;
      if (messageFilter) {
        body.message = messageFilter;
      }

      this.loadingState.next(ActionState.LOADING);
      this.isoldTableView = false;
      if (this.eUid) {
        this.alarmsService
            .getStationAlarms(
                this.eUid,
                params,
                body,
                this.limitEvent,
                this.offsetEvent
            )
            .toPromise()
            .then(
                (alarms: AlarmRealTimePaginatedList) => {
                  this.handleGetAlarmsResponse(alarms);
                  const end = performance.now();
                },
                (error) => {
                  this.handleGetAlarmsErrors(error);
                }
            );
      } else {
        this.alarmsService
            .getActiveAlarms(params, body, this.limitEvent, this.offsetEvent)
            .toPromise()
            .then(
                (alarms: AlarmRealTimePaginatedList) => {
                  this.handleGetAlarmsResponse(alarms);
                },
                (error) => {
                  this.handleGetAlarmsErrors(error);
                }
            );
    }
  }

  getBody() {
    return this.dataForChildComponent.body;
  }
  getParamsForGetEvents(event: any): void {
    // this.loggerService.log('in getParamsForGetEvents');
    const lastvalue = this.dataForChildComponent.params;
    this.dataForChildComponent.params = event;
    if (this.dataForChildComponent.params.length > 0 || lastvalue !== this.dataForChildComponent.params) {this.getAlarms(); }
  }
  getBodyForGetEvents(event: any): void {
    // this.loggerService.log('in getBodyForGetEvents');
    // si on supprime le filtre on vérifie si elle correspond à l'ancienne value
    const lastvalue = [...this.dataForChildComponent.body.filters];
    // nouvelle valeur ou filtre pas vide
    this.dataForChildComponent.body = event;
    if (this.dataForChildComponent.body.filters.length > 0 || lastvalue.length != this.dataForChildComponent.body.filters.length ) {
      this.getAlarms();
    }
  }
  handleGetAlarmsResponse(alarms: AlarmRealTimePaginatedList) {
    this.alarms = alarms;
    this.loadingState.next(ActionState.READY);
    this.createTableMapping();
    this.createPagingMapping();
  }

  handleGetAlarmsErrors(error) {
    this.loadingState.next(ActionState.READY);
    this.logger.log(error);
    const alertParams = new AlertParameters(
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      this.translate.instant('error.title')
    );
    this.alertService.showAlert(error, AlertType.ERROR, alertParams);
  }

  /***************************************  ACTIONS ON ALARMS  **********************************/
  acknowledgeAllAlarms() {
    const ackAlarmsSubscr = this.alarmsService
      .acknowledgeAllAlarms(this.eUid)
      .subscribe({
        next: (response) => {
          this.logger.trace('Alarms ack ok', response);
          this.alarms.list.forEach((alarm) => {
            alarm.state = AlarmState.RAISED_ACKNOWLEDGED;
          });
          this.createTableMapping();
        },
        error: (error: any) => {
          this.logger.log(error);
          const alertParams = new AlertParameters(
            false,
            false,
            true,
            false,
            false,
            false,
            true,
            'Erreur d\'acquittement des alarmes'
          );
          // 'Could not get svg image'
          this.alertService.showAlert(error, AlertType.ERROR, alertParams);
          this.acknowledgingAll = false;
        },
      });
    this.subscriptions.push(ackAlarmsSubscr);
  }

  /**
   *  Bouton 'ACQUITTER'
   */
  acknowledgeAlarm(alarmUid: string) {
    const acknowledgeAlarmSub = this.alarmsService
      .acknowledgeAlarm(this.eUid, alarmUid)
      .subscribe({
        next: (response) => {
          this.logger.log(`Acknowledged Alarm ${alarmUid}: ${response}`);
          const alarm: AlarmRealTime = this.alarms.list.find(
            (_alarm) => _alarm.uid === alarmUid
          );
          alarm.state = AlarmState.RAISED_ACKNOWLEDGED;
          this.createTableMapping();
        },
        error: (error: any) => {
          this.logger.error(error);
          const alertParams = new AlertParameters(
            false,
            false,
            true,
            false,
            false,
            false,
            true,
            'Erreur d\'acquittement d\'alarme'
          );
          // Could not acknowledge alarm
          this.alertService.showAlert(error, AlertType.ERROR, alertParams);
        },
      });
    this.subscriptions.push(acknowledgeAlarmSub);
  }

  /**
   * Bouton 'RETABLIR'
   */
  reactivateAlarm(alarmUid: string) {
    this.subscriptions.push(
      // TODO: replace with correct API call
      this.alarmsService.restoreAlarm(this.eUid, alarmUid).subscribe({
        next: (response) => {
          this.logger.trace(`Reactivated Alarm ${alarmUid}: ${response}`);
          const alarm: AlarmRealTime = this.alarms.list.find(
            (_alarm) => _alarm.uid === alarmUid
          );
          alarm.state = AlarmState.RAISED;
          this.createTableMapping();
        },
        error: (error: any) => {
          this.logger.error(error);
          const alertParams = new AlertParameters(
            false,
            false,
            true,
            false,
            false,
            false,
            true,
            'Erreur de rétablissement d\'alarme'
          );
          // 'Could not reactivate alarm'
          this.alertService.showAlert(error, AlertType.ERROR, alertParams);
        },
      })
    );
  }

  openResetAlarmsModal() {
    const alertAction = new AlertAction('Réarmer', 'resetAlarms');
    const alertParams = new AlertParameters(
      true,
      true,
      true,
      true,
      true,
      false,
      true,
      'Réarmement',
      'alert-triangle',
      alertAction
    );
    this.alertService.showAlert(
      `Veuillez rentrer le code`,
      AlertType.WARNING,
      alertParams
    );
  }

  onNewAlarmList() {
    this.createTableMapping();
  }

  /***************************************  PAGING MAPPING  **********************************/
  createPagingMapping() {
    this.paging = this.generatePaging();
  }

  generatePaging(): PagingModel {
    const paging = new PagingModel(
      this.alarms.paging.offset,
      this.limitEvent,
      this.alarms.paging.curItems,
      this.alarms.paging.totalItems,
      this.alarms.paging.nextItemsLink,
      this.alarms.paging.previousItemsLink
    );

    // configuration
    paging.configuration.actionIfNoLink = 'disabled';
    paging.configuration.pagingEnabled = false;
    paging.configuration.rangeEnabled = true;
    // prevLink
    const prevLinkElement = new UiIcon();
    prevLinkElement.type = IconType.FONTAWESOME;
    prevLinkElement.value = 'icon-arrow-left-circle';
    paging.configuration.prevLinkElement = prevLinkElement;
    // nextLink
    const nextLinkElement = new UiIcon();
    nextLinkElement.type = IconType.FONTAWESOME;
    nextLinkElement.value = 'icon-arrow-right-circle';
    paging.configuration.nextLinkElement = nextLinkElement;

    return paging;
  }

  eventOnClickPrevLink(event: LinkClickSateType): void {
    if (event === LinkClickSateType.ALLOWED) {
      this.onPagination('prev-event');
    }
  }

  eventOnClickNextLink(event: LinkClickSateType): void {
    if (event === LinkClickSateType.ALLOWED) {
      this.onPagination('next-event');
    }
  }

  // TODO: refacto to Paging Component
  onPagination(type: 'next-event' | 'prev-event') {
    if (type === 'next-event') {
      this.onNextPaginationEvent();
    } else if (type === 'prev-event') {
      this.onPrevPaginationEvent();
    }
  }

  onPrevPaginationEvent() {
    this.offsetEvent = this.offsetEvent - this.limitEvent;
    this.getAlarms();
  }

  onNextPaginationEvent() {
    this.offsetEvent = this.offsetEvent + this.limitEvent;
    this.getAlarms();
  }

  /***************************************  TABLE MAPPING  **********************************/
  createTableMapping() {
    const table: TableModel = this.tableAlarmListMapper.init(
      this.alarms,
      this.eUid
    );
    this.table = table;
  }

  onMouseenterRowEventOfTable(event: TableOutputRowEvent) {
    if (event.isDataRowTarget()) {
      // animation on column ACTION
      // const rowId = event.row.id;
      // const dataRow = this.table.findDataRowById(rowId);
      // const cell = dataRow.findCellByColumnId(
      //   this.tableAlarmListMapper.COLUMN_ID_ACTION
      // );
      // const valueCell = cell.findValueCellByDataId(this.tableAlarmListMapper.ID_EVENT_HISTORY);
      // valueCell.displayedValue = this.translate.instant('action.history');
      // const css = this.rightService.isDisabled(ApplicationFeature.SITE_OPERATION) ? ' d-none' : '';
      // valueCell.cssClass = css;
      // Désactivé par demande HAJA - boutons restore & acquit
      // const valueCell = cell.findValueCellByDataId(
      //   this.tableAlarmListMapper.ID_ACQUIT_ALARM
      // );
      // valueCell.displayedValue =
      //   dataRow.row.obj.state === AlarmState.RAISED
      //     ? this.translate.instant('action.acquit')
      //     : this.translate.instant('action.restore');
      // valueCell.cssClass =
      //   dataRow.row.obj.state === AlarmState.RAISED
      //     ? this.tableAlarmListMapper.CSS_CLASS_ACQUIT
      //     : this.tableAlarmListMapper.CSS_CLASS_RESTORE;
    }
  }

  onMouseleaveRowEventOfTable(event: TableOutputRowEvent) {
    if (event.isDataRowTarget()) {
      // animation on column ACTION
      // const rowId = event.row.id;
      // const dataRow = this.table.findDataRowById(rowId);
      // const cell = dataRow.findCellByColumnId(
      //   this.tableAlarmListMapper.COLUMN_ID_ACTION
      // );
      // const valueCell = cell.findValueCellByDataId(
      //   this.tableAlarmListMapper.ID_EVENT_HISTORY
      // );
      // valueCell.displayedValue = ' ';
      // valueCell.cssClass = '';
      // Désactivé par demande HAJA - boutons restore & acquit
      // const valueCell = cell.findValueCellByDataId(
      //   this.tableAlarmListMapper.ID_ACQUIT_ALARM
      // );
      // valueCell.displayedValue = ' ';
      // valueCell.cssClass =
      //   dataRow.row.obj.state === AlarmState.RAISED
      //     ? this.tableAlarmListMapper.CSS_STATE_RAISED
      //     : '';
    }
  }

  onEventOnClick(event: TableOutputEvent) {
    this.onClickAcquitBtn(event);
    this.onClicEventsBtn(event);
    // this.onClickTicketId(event);
  }

  onClickAcquitBtn(event: TableOutputEvent) {
    if (event.target.dataId === this.tableAlarmListMapper.ID_ACQUIT_ALARM) {
      const alarmUid = event.row.obj.uid;
      if (event.row.obj.state === AlarmState.RAISED) {
        this.acknowledgeAlarm(alarmUid);
      } else {
        this.reactivateAlarm(alarmUid);
      }
    }
  }

  onClicEventsBtn(event: TableOutputEvent) {
    if (event.target.dataId === this.tableAlarmListMapper.ID_EVENT_HISTORY) {
      this.goToEvents(
        event.row.obj.tag,
        event.row.obj.stationId,
        false,
        event.row.obj.dateTime
      );
    }
  }

  goToEvents(alarmTag, stationId, filterAlarms = false, date = null) {
    const url = './stations/' + stationId + '/events';
    this.router.navigate([url], {
      state: {
        alarmTag: alarmTag,
        filterAlarms: filterAlarms,
        dateAlarm: date,
      },
    });
  }

  // onClickTicketId(event: TableOutputEvent) {
  //   if (
  //     event.cell.columnId === this.tableAlarmListMapper.COLUMN_ID_TICKET_ID &&
  //     event.target.dataId === this.tableAlarmListMapper.ID_CELL_TICKET_ID
  //   ) {
  //     const obj: AlarmRealTime = event.row.obj;
  //     if (obj.ticketExternalId) {
  //       const params = {
  //         ticketId: obj.ticketExternalId,
  //       };

  //       this.router.navigate(['/tickets'], { queryParams: params });
  //     }
  //   }
  // }

  /***************************************  FILTERS EVENT  **********************************/
  exportData() {
    this.filtersConfig.export.isLoading = true;
    const params = this.dataForChildComponent.params || [];

    // Remove the given params (only effect on API is making it fail with incorrect values)
    const paramsToRemove = ['sortFieldName', 'sortDirection', 'search'];
    for (const param of paramsToRemove) {
      const index = params.findIndex((p) => p.key === param);
      if (index > -1) {
        params.splice(index, 1)
      }
    }

    this.alarmsService
        .exportAlarms(params)
        .toPromise()
        .then((response) => {
          // this.loggerService.trace ('in StationTicketsTableComponent getTickets(): got tickets');
          const filename = response.headers.get('content-disposition').split('=');
          const blob = new Blob([response.body], {
            type: response.headers.get('content-type'),
          });
          FileSaver.saveAs(blob, filename[1].slice(1, -1));
          this.filtersConfig.export.isLoading = false;
        })
        .catch((error) => {
          this.filtersConfig.export.isLoading = false;
          const title = this.translate.instant('error.title');
          const alertParams = new AlertParameters(
              false,
              false,
              true,
              false,
              false,
              false,
              true,
              title
          );
          this.alertService.showAlert(error, AlertType.ERROR, alertParams);
        });
  }

  eventReceiver(event: any) {
    const typeEvent = event.type;
    const dataEvent = event.data;
    switch (typeEvent) {
      case EventEmitterFilters.PARAMS:
        this.getParamsForGetEvents(dataEvent);
        break;
      case EventEmitterFilters.BODY:
        this.getBodyForGetEvents(dataEvent);
        break;
      case EventEmitterFilters.SHOW_HIDE_COLUMN:
        this.addRemoveColumnItem(dataEvent);
        break;
      case EventEmitterFilters.EXPORT:
          if (this.eUid) {
            this.exportDataByStation();
          } else {
            this.exportData();
          }
          break;
        default:
          return;
        }
      }
  exportDataByStation() {
    this.filtersConfig.export.isLoading = true;
    const params = this.dataForChildComponent.params || [];
    this.alarmsService
        .exportAlarmsByStation(this.eUid, params)
        .toPromise()
        .then((response) => {
          // this.loggerService.trace ('in StationTicketsTableComponent getTickets(): got tickets');
          const filename = response.headers.get('content-disposition').split('=');
          const blob = new Blob([response.body], {
            type: response.headers.get('content-type'),
          });
          FileSaver.saveAs(blob, filename[1].slice(1, -1));
          this.filtersConfig.export.isLoading = false;
        })
        .catch((error) => {
          this.filtersConfig.export.isLoading = false;
          const title = this.translate.instant('error.title');
          const alertParams = new AlertParameters(
              false,
              false,
              true,
              false,
              false,
              false,
              true,
              title
          );
          this.alertService.showAlert(error, AlertType.ERROR, alertParams);
        });
  }
  addRemoveColumnItem(event: any): void {

    const columnKey = event.columnKey;
    const show = event.show;
    this.table.dataRow.forEach((r) => {
      r.cells.forEach((c) => {
        this.showOrHideCell(c, columnKey, show);
      });
    });
    this.addRemoveColumnToTableHeader(columnKey, show);
  }

  addRemoveColumnToTableHeader(columnKey: string, show: boolean) {
    this.table.header.cells.forEach((c) => {
      this.showOrHideCell(c, columnKey, show);
    });
  }

  showOrHideCell(c: any, columnKey: string, show: boolean) {
    const types = AlarmsColumns.values();
    types.forEach((type) => {
      if (columnKey === type && c.columnId === type) {
        c.show = show;
      }
    });
  }

  ngOnDestroy() {
    this.alarms = null;
    if (this.subscriptions !== undefined) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
  }
}
